import React, {
	Fragment
	, PureComponent
	, memo
	, useCallback
	, useEffect
	, useMemo
} from 'react';
import TagsInput from 'react-tagsinput';
import { I, webRoot } from '../../../common/v5/config';
import { Area } from '../../../components/v5/ManualErrand';
import {
	TextInputRow,
	CustomInputRow
} from '../../../reactcomponents/Form';
import {
	LabelToggleSwitch as ToggleSwitch
} from '../../../components/v5/ToggleSwitch';
import { INPUT_EMPTY_WARNING, FORM_SUBMIT_EMPTY_WARNING } from '../../../common/v5/constants';
import update from 'immutability-helper';
import { UnnestedAreaSingleSelect } from '../../../reactcomponents/Dropdown';
import { TXT_NO_SELECTION } from '../../../common/v5/receiptGreetingConstants';

const helperForArea = <div>
	<div>{I("An area must be chosen because the authenticated LINE account needs to be connected with an area.")}</div>
</div>

export class AccountLINEForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			reqInputs: {
				name: {touched:false},
				channelID: {touched:false},
				channelSecret: {touched:false},
				token: {touched:false}
			}
		};

	}

	handleSelectArea = (val) => {
		this.props.onChangeAdminInput("selectedArea", val, this.props.view);
	}
	

	handleToggle = (value, field) => {
		this.props.onChangeAdminInput(field, value)
	}

	onTestToken = () =>{
		// if(this.noEmpty()) {
		if(true) {
			const {input} = this.props
			$.ajax({
				url: webRoot + 'line/account/test',
				data: {
					id: input.channelId,
					secret: input.channelSecret,
					token: input.token
				},
				cache: false,
				type: "GET",
				success: function(data) {
					//console.log("Success: "+data.token_ok);
					if(data.name) {
						alert("Success token: "+data.token_ok+" name: "+data.name);
					} else {
						alert("Valid token!");
					}
				},
				error: function(xhr) {
					if(xhr.responseJSON) {
						alert("! FAILED/invalid token: "+xhr.responseJSON.status);
					} else {
						console.log("Error loading JSON: ", xhr);
					}
				}
			});
		}
	};

	handleFieldWarning = (e) => {
		let field = e.target.name;
		let reqInputs = this.state.reqInputs;
		reqInputs = update(reqInputs,{
			[field]: {
				touched:{$set: true}
			},
		})
		this.setState({reqInputs:reqInputs})
	}

	handleSubmitFrom =(e)=> {
		e.preventDefault();
		let reqInputs = this.state.reqInputs;
		let input = this.props.input;
		let valid = true;
		//check area validity
		if (input.selectedArea === "0" || input.selectedArea.length < 1) {
			return alert(I("Please select area"));
		}
		$.each(reqInputs, (field, v)=>{
			//set required inputs touched
			reqInputs = update(reqInputs,{
				[field]: {
					touched:{$set: true}
				},
			})
			//check if empty
			if(input[field] === "" || input[field] === undefined) {
				valid = false;
			}
		});
		this.setState({reqInputs:reqInputs})
		if(valid){
			this.props.onSave();
		} else {
			alert(FORM_SUBMIT_EMPTY_WARNING);
		}
	}

	render() {
		const {
			areaList
			, input
			, onHandleTextInputChange
			, hidden
			, isNew
			, baseButtons
		} = this.props;

		let selectedArea = parseInt(input.selectedArea, 10);
		const field = this.state.reqInputs;
		const warnTxt = INPUT_EMPTY_WARNING;

		return (
			<form onSubmit={this.handleSubmitFrom} className="admin-one-form edit-admin-form" hidden={hidden}>
				<CustomInputRow
					id={"area"}
					name={"area"}
					label={I('Area')}
					className={"admin-dropdown-select"}
					mandatory={true}
					helper={helperForArea}
				>
					<UnnestedAreaSingleSelect
						data={areaList}
						invalidSelectedText={TXT_NO_SELECTION}
						onSelect={this.handleSelectArea}
						selected={selectedArea}
						nested={{key: 'Areas'}}
						idFields={{id: "Id", name: "Name"}}
					/>
				</CustomInputRow>
				<TextInputRow
					id={"name"}
					name={"name"}
					className="admin-text-input"
					label={I("Name")}
					value={input.name || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.name && field.name.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
				/>
				<ToggleSwitch
					id={"enable"}
					name={"enable"}
					data-qa-id="enableLine"
					label={I("Activated")}
					checked={input.enable}
					onClick={this.handleToggle}
					listWrap={false}
					className="admin-text-input"
				/>
				<TextInputRow
					id={"channelID"}
					name={"channelID"}
					className="admin-text-input"
					label={I("Channel ID")}
					value={input.channelID || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.channelID && field.channelID.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
				/>
				<TextInputRow
					type={"password"}
					id={"channelSecret"}
					name={"channelSecret"}
					className="admin-text-input"
					label={I("Channel secret")}
					value={input.channelSecret || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.channelSecret && field.channelSecret.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
				/>
				<TextInputRow
					id={"token"}
					name={"token"}
					className="admin-text-input"
					label={I("Access Token")}
					value={input.token || ""}
					onChange={onHandleTextInputChange}
					mandatory={true}
					warning={(!input.token && field.token.touched) && warnTxt}
					onBlur={this.handleFieldWarning}
				/>
				<div className="label-row">
					<div className="label-block">
						<div className="label-admin-text-input">
							<label htmlFor="admin-text-input">{I("Test Token")}</label>
						</div>
						<button type="button" className="btn-blue LINE-test-btn" title="Test" data-qa-id="btn-Test" onClick={this.onTestToken}>{I("Test")}</button>
					</div>
				</div>
				{baseButtons}
			</form>
		)
	}
}